import * as actions from './actions';

const initialState = () => {
    return {
        isBusy: false,
        items: [],
        error: null
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.FETCH_BROKERAGES:
            return {
                ...state,
                isBusy: true,
                error: null
            };
        case actions.FETCH_BROKERAGES_SUCCESS:
            return {
                ...state,
                isBusy: false,
                items: action.value
            };
        case actions.FETCH_BROKERAGES_FAILURE:
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        case actions.SYNC_WITH_SALESFORCE:
            return {
                ...state,
                isSalesforceSyncBusy: true,
                salesforceSyncError: null,
                salesforceSuccessfulUpdates: null
            };
        case actions.SYNC_WITH_SALESFORCE_SUCCESS:
            return {
                ...state,
                isSalesforceSyncBusy: false,
                salesforceSyncError: null,
                salesforceSuccessfulUpdates: action.payload.data
            };
        case actions.SYNC_WITH_SALESFORCE_FAILURE:
            return {
                ...state,
                isSalesforceSyncBusy: false,
                salesforceSyncError: action.payload.error?.message,
                salesforceSuccessfulUpdates: null
            };
        case actions.SYNC_WITH_SALESFORCE_RESET:
            return {
                ...state,
                isSalesforceSyncBusy: false,
                salesforceSyncError: null,
                salesforceSuccessfulUpdates: null
            }
        default:
            return state;
    }
}
